import * as React from 'react';
import { RenderProviderContext } from './context';
export const useRenderContent = (...args) => {
    const provider = React.useContext(RenderProviderContext);
    if (!provider) {
        return;
    }
    return provider(...args);
};
//# sourceMappingURL=useRenderContent.js.map